import React from 'react';
import "../DownArrow.css";

const DownArrow = () => {
  const handleClick = () => {
    const projectFeedHeader = document.querySelector('.project-feed-header');
    if (projectFeedHeader) {
      projectFeedHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="down-arrow-wrapper">
      <button type="button" className="down-arrow-button" onClick={handleClick} aria-label="Scroll to projects">
        <svg className="down-arrow-svg" viewBox="0 0 64 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 10 L32 30 L56 10" stroke="lightgray" strokeWidth="3" strokeLinecap="butt" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
};

export default DownArrow;